// the image list on de.career.saargummi.com allows to open links in modal overlay
import qs from 'qs'

const closeModal = (e) => {
  setTimeout(function() {
    $('body')
      .removeAttr('scroll')
      .css({ overflow: 'auto' })
    e.remove()
  }, 500)

  $('.slide-modal-background, .slide-modal-pane').addClass('enter')

  history.replaceState({}, document.title, '?')
}

const showModal = (sel) => {
  $('.slide-modal').remove()
  // template
  const mhtml = $(sel).html()
  const modal = $(mhtml).appendTo('body')

  const bg = modal.find('.slide-modal-background')
  // background close
  bg.on('click', () => closeModal(modal))
  // close btn
  $('[data-dismiss="modal"]', modal).on('click', () => closeModal(modal))

  // dont scroll on body
  $('body')
    .attr('scroll', 'no')
    .css({ overflow: 'hidden' })

  // animation
  setTimeout(function() {
    $('.enter', modal).removeClass('enter')
  }, 1)

  return modal
}

const loadPage = (url) => {
  $('.slide-modal').addClass('loading')
  $.get(`${url}`, (res) => {
    $('.slide-modal').removeClass('loading')
    const $res = $(res)
    $res.find('.node-sitemap').remove()
    $('.slide-modal [data-slide-modal-content-placeholder]').html($res.find('.main-container').html())
  })
}

const loadPageToIFrame = (url) => {
  $('.slide-modal')
    .addClass('loading')
    .addClass('iframe')
  var iframe = document.createElement('iframe')

  url += url.match(/\?/) ? '&slide_modal_iframe=1' : '?slide_modal_iframe=1'
  url += `&cb${new Date().getTime()}`

  iframe.src = url
  iframe.onload = () => {
    $('.slide-modal').removeClass('loading')
  }

  $('[data-slide-modal-content-placeholder]').html(iframe)
}

// window.hello = function () {
//     alert('hello from owner!');
// };

// $(iframeDoc).ready(function (event) {
//     iframeDoc.open();
//     iframeDoc.write('iframe here');
//     iframeDoc.write('\<script>alert("hello from iframe!");\<\/script>');
//     iframeDoc.write('\<script>parent.hello();\<\/script>');
//     iframeDoc.close();
// });

const setupClickHandler = ($) =>
  $(document).on('click', '.node-image-list a[data-target="modal_overlay"]', function(e) {
    e.preventDefault()
    showModal('#modal-tmpl')

    loadPage($(this).attr('href'))
  })

const setupClickHandlerIFrame = ($) =>
  $(document).on('click', '[data-target="modal_overlay"]', function(e) {
    e.preventDefault()
    showModal('#modal-tmpl')

    const overlayURL = $(this).attr('href')
    loadPageToIFrame(overlayURL)
    pushState({ overlayURL })
  })

const setup = ($) => {
  if (window.location !== window.parent.location && $('body').hasClass('slide-modal-iframe')) {
    // The page is in an iframe
    setTimeout(function() {
      $('a').attr('target', '_top')
      console.log('IFRAME', $('a').length)
    }, 100)
  } else {
    setupClickHandlerIFrame($)

    const q = qs.parse(location.search.substr(1))
    if ('overlayURL' in q) {
      const { overlayURL } = q
      showModal('#modal-tmpl')
      loadPageToIFrame(overlayURL)
      pushState({ overlayURL })
    }
    // The page is not in an iframe
  }
  // if (!$('.node-image-list a[data-target="modal_overlay"]').get(0)) {

  //   return
  // }
  // setupClickHandler($)
}

const pushState = ({ overlayURL, url }) => {
  if ('pushState' in history) {
    let url = ``
    if (overlayURL) {
      url += `?overlayURL=${overlayURL}`
    }

    history.pushState({ type: 'show_in_modal', overlayURL }, '' + document.title, url)
  }
}

const setupPopstate = ($) => {
  window.onpopstate = function(event) {
    if (event.state && typeof event.state === 'object' && event.state.type === 'show_in_modal') {
      const { iframeURL } = event.state
      if (iframeURL) {
        showModal('#modal-tmpl')
        loadPage(iframeURL)
      }
    }
  }
}

export default setup



// WEBPACK FOOTER //
// app/javascript/sg/js/open_in_modal.js